const noop = () => {};

/**
 * Async/await helper for setTimeout
 * @param {Number} time
 * @returns a promise that resolves after the given time
 */
function timeout(time) {
  return new Promise(resolve => {
    setTimeout(() => resolve(), time);
  });
}
export { noop, timeout };